import { CustomTag } from './custom-tag';

export class ConditionFilterDeviceLog {
  id: Number;
  email: String;
  customTag1: CustomTag;
  customTag2: CustomTag;
  customTag3: CustomTag;
  customTag4: CustomTag;
  customTag5: CustomTag;
  deviceId: string;
  conditions: any;
  customTagElement1Ids: Array<number>;
  customTagElement2Ids: Array<number>;
  customTagElement3Ids: Array<number>;
  customTagElement4Ids: Array<number>;
  customTagElement5Ids: Array<number>;

  constructor(email?: String, conditions?: any) {
    this.email = email;
    this.conditions = conditions;
  }
}
